class HistoryEntry {
  constructor(id, visitDetail, mileage) {
    this.id = id;
    this.visitDetail = visitDetail;
    this.mileage = mileage;
  }
}

export default HistoryEntry;
